import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthLayout from '../components/AuthLayout'
import { useUserProfile } from '../context/UserProfileContext'

export default function AuthLoadingPage() {
  const navigate = useNavigate()
  const { isLoadingUser, refetchUser, user } = useUserProfile()
  const [progress, setProgress] = useState(20)
  const [hasStartedFetch, setHasStartedFetch] = useState(false)

  useEffect(() => {
    // Fetch user profile on mount
    if (!hasStartedFetch) {
      setHasStartedFetch(true)
      refetchUser()
    }
  }, [hasStartedFetch, refetchUser])

  useEffect(() => {
    // Animate progress bar
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 90) return 90
        return prev + 10
      })
    }, 200)

    return () => clearInterval(progressInterval)
  }, [])

  useEffect(() => {
    // Once user is loaded and we have user data, complete progress and navigate
    if (!isLoadingUser && user && hasStartedFetch) {
      setProgress(100)
      const timer = setTimeout(() => {
        navigate('/dashboard')
      }, 500)

      return () => clearTimeout(timer)
    }
    return undefined
  }, [isLoadingUser, user, hasStartedFetch, navigate])

  return (
    <AuthLayout>
      <div className='space-y-6'>
        <div className='space-y-4'>
          <h1 className='text-2xl font-bold text-gray-900'>Logging in</h1>
          <div className='w-full bg-gray-200 rounded-full h-2'>
            <div
              className='bg-[#001B38] h-2 rounded-full transition-all duration-300'
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className='text-sm text-gray-600'>
            {isLoadingUser ? 'Loading your profile...' : 'Redirecting to dashboard...'}
          </p>
        </div>
      </div>
    </AuthLayout>
  )
}
